import {
  fetcher,
  messageFromApiErrorBody,
  readJsonResponseBody,
} from '@commenda/utils';

export async function deleteRootFiCompany(rootFiCompanyId: number): Promise<{
  success: boolean;
  error?: unknown;
}> {
  try {
    const response = await fetcher(`rootfi/company/${rootFiCompanyId}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      const errorBody = await readJsonResponseBody(response);
      return {
        success: false,
        error: messageFromApiErrorBody(errorBody, 'Failed to delete connection'),
      };
    }

    return { success: true };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to delete connection';
    return { success: false, error: errorMessage };
  }
}
